import { field, formatUnits, readContract, writeContractAndWait } from "../viem";
import config from "../../config/config";

import MafiaBulletFactoryAbi from "../../abis/MafiaBulletFactory.json";

const address = config.bulletFactoryAddress;
const abi = MafiaBulletFactoryAbi;

export const getCityMarketInfo = async (cityId: number) => {
  const cityMarketInfo: any = await readContract({
    address,
    abi,
    functionName: "getCityMarketInfo",
    args: [cityId],
  });

  return {
    price: Number(formatUnits(field(cityMarketInfo, "price", 0), 18)),
    amountLeft: Number(field(cityMarketInfo, "amountLeft", 1)),
    lastUpdateTime: Number(field(cityMarketInfo, "lastUpdateTime", 2)),
  };
};

export const buyBullets = async (
  account: string,
  bulletAmount: number,
  message: string,
  signature: string
) => {
  const txData = await writeContractAndWait({
    address,
    abi,
    functionName: "buyBullets",
    args: [bulletAmount, JSON.stringify(message), signature],
    account,
    gasMultiplier: 5,
  });

  return txData;
};

export const claimBulletFactoryProfit = async (
  account: string,
  cityId: number
) => {
  const txData = await writeContractAndWait({
    address,
    abi,
    functionName: "claimProfit",
    args: [cityId],
    account,
  });

  return txData;
};

export const getBulletMarketUpdateInterval = async () => {
  const updateInterval: number = await readContract({
    address,
    abi,
    functionName: "updateInterval",
  });
  return Number(updateInterval);
};

export const getNextBulletBuyTime = async (account: string) => {
  const nextBuyTime: number = await readContract({
    address,
    abi,
    functionName: "nextBuyTime",
    args: [account],
  });
  return Number(nextBuyTime);
};

export const reproduceBullets = async (account: string, cityId: number) => {
  const txData = await writeContractAndWait({
    address,
    abi,
    functionName: "reproduceBullets",
    args: [cityId],
    account,
  });

  return txData;
};